var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossSeachIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.947954 9.99482C0.702781 10.0092 0.461664 9.92679 0.275445 9.76485C-0.091815 9.39111 -0.091815 8.78748 0.275445 8.41374L8.31723 0.27835C8.69921 -0.0832431 9.29861 -0.0631424 9.65604 0.323285C9.97926 0.672729 9.9981 1.20983 9.70015 1.58156L1.61098 9.76485C1.42716 9.92446 1.18991 10.0068 0.947954 9.99482Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98029 9.99482C8.73181 9.99375 8.49366 9.89397 8.31723 9.71695L0.275414 1.58152C-0.0648335 1.17957 -0.0185751 0.574655 0.378754 0.230417C0.733381 -0.0768058 1.25638 -0.0768058 1.61098 0.230417L9.70015 8.36581C10.082 8.7275 10.1018 9.3339 9.74425 9.72023C9.73003 9.7356 9.71534 9.75046 9.70015 9.76485C9.50208 9.9391 9.2414 10.0224 8.98029 9.99482Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossSeachIcon);
export default __webpack_public_path__ + "static/media/CrossSeachIcon.f5e109ff230d41943500bffcc050b256.svg";
export { ForwardRef as ReactComponent };